import React from 'react'

export const NameIcon = () => {
  return (
<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 7.00001C4.125 7.00001 2.625 5.52501 2.625 3.72501C2.625 1.92501 4.125 0.450012 6 0.450012C7.875 0.450012 9.375 1.92501 9.375 3.72501C9.375 5.52501 7.875 7.00001 6 7.00001ZM6 1.57501C4.75 1.57501 3.75 2.55001 3.75 3.72501C3.75 4.90001 4.75 5.87501 6 5.87501C7.25 5.87501 8.25 4.90001 8.25 3.72501C8.25 2.55001 7.25 1.57501 6 1.57501Z" fill="#323232"/>
<path d="M10.9248 15.575H1.0748C0.574805 15.575 0.174805 15.175 0.174805 14.675V12.425C0.174805 9.97504 2.1748 7.97504 4.6248 7.97504H7.3998C9.8498 7.97504 11.8498 9.97504 11.8498 12.425V14.675C11.8248 15.15 11.4248 15.575 10.9248 15.575ZM1.2998 14.45H10.7248V12.425C10.7248 10.6 9.2248 9.10004 7.3998 9.10004H4.5998C2.7748 9.10004 1.2748 10.6 1.2748 12.425V14.45H1.2998Z" fill="#323232"/>
</svg>
  )
}
